// extracted by mini-css-extract-plugin
module.exports = {"register-form":"RegisterForm_register-form__3gBc2","register-form__rules":"RegisterForm_register-form__rules__3lnen"};